import { Box, Button, Checkbox, TextField, Typography } from "@mui/material";
import { useGetEnsembleQuery } from "../../../redux/features/cache";
import { ProduitQuantite } from "../../../models/ProduitQuantite";
import { useState } from "react";
import { padZerosLeft } from "../../../commons/helpers/StringHelper";
import { PTR_LENGTH } from "../../../constante/produits";

interface PlanoProduitsModalProps {
  prodNum: number;
  ensembleValues: ProduitQuantite[];
  closeModal: any;
  update: any;
}

export default function PlanoProduitsModal(props: PlanoProduitsModalProps) {
  const [isDirty, setIsDirty] = useState<boolean>(false);
  const [currentEnsembleValues, setCurrentEnsembleValues] = useState<
    ProduitQuantite[]
  >(JSON.parse(JSON.stringify(props.ensembleValues)));
  const { data: ensembles = [] } = useGetEnsembleQuery(props.prodNum);

  const handleSubmit = async () => {
    props.update(currentEnsembleValues);
    props.closeModal();
  };

  return (
    <>
      {ensembles.map((ensemble, i) => {
        const ptr = padZerosLeft(ensemble.prod_num, PTR_LENGTH);
        const currentEnsemble = currentEnsembleValues.find(
          (e) => e.prod_num === ensemble.prod_num
        );
        return (
          <Box
            key={i}
            display={"flex"}
            width={"100%"}
            gap={4}
            alignItems={"center"}
            sx={{
              cursor: "pointer",
              "&:hover": {
                backgroundColor: "#c9c9c9",
              },
            }}
            onClick={() => {
              if (!isDirty) setIsDirty(true);

              const element = currentEnsembleValues.find(
                (c) => c.prod_num === ensemble.prod_num
              );
              if (element) {
                const newValues = currentEnsembleValues.filter(
                  (c) => c.prod_num !== ensemble.prod_num
                );
                setCurrentEnsembleValues(newValues);
              } else {
                const newValues = [
                  ...currentEnsembleValues,
                  {
                    prod_num: ensemble.prod_num,
                    plano_qte: 1,
                  },
                ];
                setCurrentEnsembleValues(newValues);
              }
            }}
          >
            <Checkbox
              checked={
                currentEnsembleValues.filter(
                  (f) => f.prod_num === ensemble.prod_num
                ).length > 0
              }
            />
            <TextField
              label="Quantité"
              type="number"
              sx={{ width: "100px" }}
              InputLabelProps={{
                shrink: true,
              }}
              value={currentEnsemble ? currentEnsemble.plano_qte : 0}
              InputProps={{ inputProps: { min: 1, max: 100 } }}
              onChange={(e) => {
                if (!isDirty) setIsDirty(true);
                if (e.target.value !== "") {
                  const ensembleAModifier = currentEnsembleValues.find(
                    (e) => e.prod_num === ensemble.prod_num
                  );
                  ensembleAModifier!.plano_qte = Number(e.target.value);
                  setCurrentEnsembleValues(
                    JSON.parse(JSON.stringify(currentEnsembleValues))
                  );
                }
              }}
              disabled={!currentEnsemble}
              onClick={(e) => {
                e.stopPropagation();
              }}
            />
            <Box
              display={"flex"}
              flexDirection={"column"}
              flexGrow={1}
              alignItems={"center"}
            >
              <Typography mt={2} mb={2}>
                {ptr}
              </Typography>
              <Typography variant="caption">
                Categorie: {ensemble.cat_cd}
              </Typography>
              <Typography variant="caption">
                Département: {ensemble.dept_cd}
              </Typography>
              <Typography variant="caption">
                Modèle: {ensemble.mod_cd}
              </Typography>
            </Box>
            <img
              width={150}
              height={150}
              src={
                ensemble.prod_web
                  ? `https://cdn.tanguay.ca/images/products/1024px/${ensemble.prod_num}.jpg?iv=3`
                  : "https://cdn.tanguay.ca/images/products/1024px/empty_photo.jpg"
              }
              alt="Produit"
              style={{ flexGrow: 0, padding: "10px" }}
            />
          </Box>
        );
      })}
      <Box display={"flex"} justifyContent={"center"} gap={2} mt={3}>
        <Button
          variant="contained"
          disabled={!isDirty}
          onClick={() => handleSubmit()}
        >
          Confirmer
        </Button>
        <Button variant="contained" onClick={props.closeModal}>
          Annuler
        </Button>
      </Box>
    </>
  );
}
